import {
    CREATE_JOB_WORK_ISSUE,
    DELETE_JOB_WORK_ISSUE,
    GET_JOB_WORK_ISSUE,
    JOB_WORK_ISSUE_REQUEST,
    JOB_WORK_ISSUE_REQUEST_FAILURE,
    UPDATE_JOB_WORK_ISSUE,
    GET_JOB_WORK_ISSUES_PAGE,
    JOB_WORK_ISSUE_REQUEST_SUCCESS,
    GET_JOB_WORK_ISSUE_AVAILABLE_TRANSACTIONS,
    JOB_WORK_ISSUE_TRANSACTION_AVAILABLE_REQUEST,
    JOB_WORK_ISSUE_TRANSACTION_AVAILABLE_REQUEST_FAILURE
  } from "../types/job-work-issue-types";
  
  const initialState = {
    jobWorkIssue: [],
    jobWorkIssuesPage: [],
    availableTransactions: [],
    loading: false,
    error: null,
  };
  
  const jobWorkIssueReducer = (state = initialState, action) => {
    switch (action.type) {
      case JOB_WORK_ISSUE_REQUEST: {
        return {
          ...state,
          loading: true,
          error: null
        }
      }
      case GET_JOB_WORK_ISSUE: {
        return {
          ...state,
          jobWorkIssue: [...action.payload],
          loading: false,
          error: null
        }
      }
      case GET_JOB_WORK_ISSUES_PAGE: {
        const { data, total, page, pageSize, search, where } = action.payload || {};
        return {
          ...state,
          jobWorkIssuesPage: [...data],
          total,
          page,
          pageSize,
          search: search || '',
          where: where || {},
          loading: false,
          error: null
        }
      }
      case CREATE_JOB_WORK_ISSUE:
        return {
          ...state,
          jobWorkIssue: [action.payload, ...state.jobWorkIssue],
          loading: false,
          error: null
        };
      case UPDATE_JOB_WORK_ISSUE:
        const jobWorkIssueData = state.jobWorkIssue.slice(0);
        const uIndex = jobWorkIssueData.findIndex((data) => data.id === action.payload.id);
        jobWorkIssueData.splice(uIndex, 1, { ...action.payload.data });
        
        return {
          ...state,
          jobWorkIssue: [ ...jobWorkIssueData ],
          loading: false,
          error: null
        };
      case DELETE_JOB_WORK_ISSUE:
        const jobWorkIssue = state.jobWorkIssue?.slice(0);
        const index = jobWorkIssue.findIndex((data) => data.id === action.id);
        if (index > -1) {
          jobWorkIssue.splice(index, 1);
        }
        return {
          ...state,
          jobWorkIssue: [...jobWorkIssue],
          loading: false,
          error: null
        }
      case JOB_WORK_ISSUE_REQUEST_SUCCESS: {
        return {
          ...state,
          loading: false,
          error: null
        }
      }
      case JOB_WORK_ISSUE_REQUEST_FAILURE: {
        return {
          ...state,
          loading: false,
          error: action.error
        }
      }
      case JOB_WORK_ISSUE_TRANSACTION_AVAILABLE_REQUEST: {
        return {
          ...state,
          loading: true,
          error: null
        }
      }
      case GET_JOB_WORK_ISSUE_AVAILABLE_TRANSACTIONS: {
        return {
          ...state,
          availableTransactions: [ ...action.payload ],
          loading: false,
          error: null
        }
      }
      case JOB_WORK_ISSUE_TRANSACTION_AVAILABLE_REQUEST_FAILURE: {
        return {
          ...state,
          loading: false,
          error: action.error
        }
      }
      default:
        return state;
    }
  };
  
  export default jobWorkIssueReducer;
  